module.exports = "/_next/static/images/kate-hudson@2x-5bf9c7e9067f77a68d8df850a6a5a799.png";